import { ReactElement, useEffect, useMemo } from 'react'
import Footer from '../../components/footer'
import Frame from '../../components/frame'
import H2 from '../../components/h2'
import Table from '../../components/table'
import { useLabs } from '../../hooks/labs'
import Navigation from '../navigation'

const LabsList = (): ReactElement | null => {
  const { labs, get } = useLabs()

  useEffect(() => {
    get()
  }, [get])

  const columns = useMemo(() => {
    return [
      {
        title: 'Laboratório',
        dataIndex: 'name'
      },
      {
        title: 'Logo',
        dataIndex: 'image',
        // eslint-disable-next-line react/display-name
        render: (img: string) => <img alt='logo' src={img} style={{ height: 45, width: 'auto' }} />
      },
      {
        title: 'País',
        dataIndex: 'countryCode'
      },
      {
        title: 'Estado',
        dataIndex: 'stateCode'
      }
    ]
  }, [])

  return (
    <div style={{ backgroundColor: 'white' }}>
      <Navigation />
      <Frame style={{ marginTop: 100, marginBottom: 100 }}>
        <H2>
          Laboratórios
          <br />
          <span>Todos nossos laboratórios homologados</span>
        </H2>
        <div style={{ marginTop: 50 }}>
          <Table
            columns={columns}
            data={labs}
          />
        </div>
      </Frame>
      <Footer />
    </div>
  )
}

export default LabsList
